let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kUccM")).then(() => parcelRequire('gUnLs'));